var _rect, _path, _path2, _path3, _circle, _circle2, _ellipse, _rect2, _rect3, _rect4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 209,
    viewBox: "0 0 250 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.1973,
    y: 1.59961,
    width: 196.802,
    height: 150.299,
    rx: 4,
    stroke: "#16BAE7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.831 137.21C62.8597 135.605 60.6569 136.763 59.8019 137.543C53.9708 143.206 41.6712 155.091 39.1223 157.323C36.5735 159.556 37.1649 161.753 37.7792 162.572C39.2149 164.06 42.5791 167.437 44.5504 169.041C46.5217 170.646 48.671 169.843 49.4993 169.241L70.8802 148.477C72.4352 146.966 72.2631 145.414 71.9826 144.827C70.7273 143.366 66.8023 138.815 64.831 137.21Z",
    fill: "#00233A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.291 5.50001C52.291 3.29086 54.0819 1.5 56.291 1.5H244.128C246.337 1.5 248.128 3.29086 248.128 5.5V21.4818H52.291V5.50001Z",
    stroke: "#16BAE7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6485 154.631C39.7372 152.23 36.4745 153.975 35.207 155.148C26.5615 163.665 8.32573 181.539 4.54748 184.898C0.769227 188.257 1.63708 191.551 2.5433 192.778C4.66254 195.006 9.62886 200.063 12.5402 202.465C15.4514 204.867 18.6339 203.655 19.8612 202.748L51.5616 171.519C53.8671 169.248 53.6175 166.919 53.2045 166.039C51.352 163.851 45.5598 157.033 42.6485 154.631Z",
    fill: "#16BAE7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9952,
    cy: 116.083,
    r: 50.1629,
    transform: "rotate(8.55885 90.9952 116.083)",
    fill: "#00233A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9939,
    cy: 116.086,
    r: 33.9813,
    transform: "rotate(8.55885 90.9939 116.086)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.708,
    cy: 7.79687,
    rx: 3.23632,
    ry: 3.23632,
    fill: "#00233A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5264,
    y: 49.959,
    width: 93.8532,
    height: 3.23632,
    transform: "rotate(0.635041 61.5264 49.959)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5264,
    y: 31.4688,
    width: 93.8532,
    height: 3.23632,
    transform: "rotate(0.635041 61.5264 31.4688)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5264,
    y: 41.0703,
    width: 93.8532,
    height: 3.23632,
    transform: "rotate(0.635041 61.5264 41.0703)",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.593 132.659C188.392 132.659 187.247 132.434 186.157 131.983C185.067 131.533 184.074 130.895 183.176 130.069L147.038 93.9311C146.212 93.0304 145.574 92.0352 145.124 90.9454C144.673 89.8557 144.448 88.7118 144.448 87.514C144.448 86.3131 144.673 85.1498 145.124 84.024C145.574 82.8982 146.212 81.9225 147.038 81.0969L183.176 44.9585C184.077 44.0579 185.072 43.4004 186.162 42.9861C187.251 42.5718 188.395 42.3662 189.593 42.3692C190.794 42.3692 191.957 42.5763 193.083 42.9906C194.209 43.4049 195.185 44.0609 196.01 44.9585L232.149 81.0969C233.049 81.9225 233.707 82.8982 234.121 84.024C234.535 85.1498 234.741 86.3131 234.738 87.514C234.738 88.7148 234.532 89.8602 234.121 90.9499C233.71 92.0397 233.052 93.0334 232.149 93.9311L196.01 130.069C195.185 130.895 194.209 131.533 193.083 131.983C191.957 132.434 190.794 132.659 189.593 132.659ZM185.09 92.0172H194.096V64.9979H185.09V92.0172ZM189.593 105.527C190.869 105.527 191.939 105.095 192.804 104.23C193.668 103.365 194.099 102.297 194.096 101.024C194.096 99.7477 193.664 98.6775 192.799 97.8129C191.935 96.9482 190.866 96.5174 189.593 96.5204C188.317 96.5204 187.247 96.9527 186.382 97.8174C185.518 98.682 185.087 99.7507 185.09 101.024C185.09 102.3 185.522 103.37 186.387 104.234C187.251 105.099 188.32 105.53 189.593 105.527Z",
    fill: "#16BAE7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no_result.65cc57db79c568c726dadc3d61fed917.svg";
export { ForwardRef as ReactComponent };